
import React from 'react';
import { Route } from 'react-router-dom';
import RoleProtectedRoute from '@/components/RoleProtectedRoute';
import BoardroomDashboard from '@/pages/ai/BoardroomDashboard';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import DebugRoutes from '@/pages/debug/DebugRoutes';

export const AIAndAdminRoutes = () => (
  <>
    {/* AI Systems */}
    <Route path="/ai/boardroom" element={<RoleProtectedRoute allowedRoles={['admin']}><BoardroomDashboard /></RoleProtectedRoute>} />
    <Route path="/ai/boardroom/miles" element={<RoleProtectedRoute allowedRoles={['admin']}><BoardroomDashboard /></RoleProtectedRoute>} />
    <Route path="/ai/boardroom/giselle" element={<RoleProtectedRoute allowedRoles={['admin']}><BoardroomDashboard /></RoleProtectedRoute>} />
    <Route path="/ai/boardroom/devon" element={<RoleProtectedRoute allowedRoles={['admin']}><BoardroomDashboard /></RoleProtectedRoute>} />
    <Route path="/ai/boardroom/alma" element={<RoleProtectedRoute allowedRoles={['admin']}><BoardroomDashboard /></RoleProtectedRoute>} />
    <Route path="/ai/agent-script-library" element={<RoleProtectedRoute allowedRoles={['admin']}><BoardroomDashboard /></RoleProtectedRoute>} />
    <Route path="/ai/voice-agent" element={<RoleProtectedRoute allowedRoles={['admin']}><BoardroomDashboard /></RoleProtectedRoute>} />
    <Route path="/ai/simulation" element={<RoleProtectedRoute allowedRoles={['admin']}><BoardroomDashboard /></RoleProtectedRoute>} />

    {/* Admin Utilities */}
    <Route path="/admin" element={<RoleProtectedRoute allowedRoles={['admin']}><AdminDashboard /></RoleProtectedRoute>} />
    <Route path="/admin/impersonate/:userId" element={<RoleProtectedRoute allowedRoles={['admin']}><AdminDashboard /></RoleProtectedRoute>} />
    <Route path="/admin/audit-log" element={<RoleProtectedRoute allowedRoles={['admin']}><AdminDashboard /></RoleProtectedRoute>} />
    <Route path="/admin/system-metrics" element={<RoleProtectedRoute allowedRoles={['admin']}><AdminDashboard /></RoleProtectedRoute>} />
    <Route path="/admin/backups" element={<RoleProtectedRoute allowedRoles={['admin']}><AdminDashboard /></RoleProtectedRoute>} />
    <Route path="/admin/database" element={<RoleProtectedRoute allowedRoles={['admin']}><AdminDashboard /></RoleProtectedRoute>} />

    {/* Developer Tools */}
    <Route path="/debug/routes" element={<DebugRoutes />} />
    <Route path="/debug/components" element={<DebugRoutes />} />
    <Route path="/debug/credits" element={<DebugRoutes />} />
  </>
);
